export const en = {
    'audio-url': 'Link to audio file',
    cancel: 'Cancel',
    'image-url': 'Image URL address',
    upload: 'Upload',
    'video-url': 'Link to video'
};
